module.exports = __webpack_public_path__ + "static/media/minturbo.11ddf8a7.png";